/** Month full names — index 0 = January */
export const BATCH_SCAN_MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

function capitalizeWords(s: string) {
  const t = s.trim();
  if (!t) return "";
  return t.replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Simple plural for unit types in batch-scan lines (English). */
export function pluralizeBatchUnit(quantity: number, unitType: string): string {
  const raw = (unitType || "unit").trim() || "unit";
  const u = capitalizeWords(raw);
  if (quantity === 1) return u;
  if (/s$/i.test(u)) return u;
  if (/box$/i.test(u)) return `${u}es`;
  return `${u}s`;
}

/**
 * Dashboard primary line: "10 Bottles of Allergex 2mg/5ml Syrup · Exp October 2028"
 */
export function buildBatchScanLineDisplay(params: {
  quantity: number;
  unitType: string;
  name: string;
  strength: string;
  dosageForm: string;
  expiryMonth: number;
  expiryYear: number;
}): string {
  const q = Math.max(1, Math.min(999, Math.floor(Number(params.quantity)) || 1));
  const unitLabel = pluralizeBatchUnit(q, params.unitType);
  const name = (params.name || "Medicine").trim() || "Medicine";
  const strength = (params.strength || "").trim();
  const form = (params.dosageForm || "").trim();
  const core = [name, strength, form].filter(Boolean).join(" ");
  const m = params.expiryMonth;
  const monthName =
    Number.isInteger(m) && m >= 1 && m <= 12 ? BATCH_SCAN_MONTH_NAMES[m - 1] : "";
  return `${q} ${unitLabel} of ${core} · Exp ${monthName} ${params.expiryYear}`.replace(
    /\s+/g,
    " ",
  );
}

export function formatBatchScanExpiryLabel(month: number, year: number): string {
  if (!Number.isInteger(month) || month < 1 || month > 12) return "";
  return `${BATCH_SCAN_MONTH_NAMES[month - 1]} ${year}`;
}
